import { createFileRoute } from "@tanstack/react-router"

import { issueTypePriorityViewStaticData } from "../../../../../../../../views/IssueTypeSettingsPriorityView/constants"
import { IssueTypeSettingsPriorityView } from "../../../../../../../../views/IssueTypeSettingsPriorityView/IssueTypeSettingsPriorityView"

export const Route = createFileRoute(
	"/_loggedIn/$organizationId/_map/_layout/settings/issue-types/$issueTypeId/priorities",
)({
	component: IssueTypeSettingsPriorityView,
	staticData: issueTypePriorityViewStaticData,
})
